import React, { useState, useEffect } from 'react';
import { auth } from './firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import LoginPage from './pages/LoginPage';
import AdminCalendar from './pages/AdminCalendar';
import ReadOnlyCalendar from './pages/ReadOnlyCalendar';
import './index.css';

const VIEW_TOKEN = 'gh-view-a1d2i3';

export default function App() {
  const [user, setUser] = useState(undefined);
  const path = window.location.pathname;

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => setUser(u));
    return unsub;
  }, []);

  if (user === undefined) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="spinner" /></div>;
  }

  if (path === `/view/${VIEW_TOKEN}`) return <ReadOnlyCalendar />;
  if (user) return <AdminCalendar />;
  return <LoginPage />;
}
